import { Component, Input, OnInit } from '@angular/core';
import { Menu } from 'src/app/models/menu';

@Component({
  selector: '[app-sub-menu]',
  templateUrl: './app-sub-menu.component.html',
  styleUrls: ['./app-sub-menu.component.less']
})
export class AppSubMenuComponent implements OnInit {
  @Input() menu: Menu;

  constructor() { }

  ngOnInit(): void {
  }

  getMenuUrl(menu: Menu): any {
    return Menu.getMenuUrl(menu);
  }
}
